import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from 'lodash';
import { getAvailableSchedulesAPI } from './api';

export function expandAvailableSchedules(subscriptionId) {
    this.availableSchedulesExpanded[subscriptionId] = true;
    this.observed.availableSchedulesExpanded = uuidv4();
}

export function closeAvailableSchedules(subscriptionId) {
    this.availableSchedulesExpanded[subscriptionId] = false;
    this.observed.availableSchedulesExpanded = uuidv4();
}

async function getAvailableSchedules(subscriptionId) {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.isLoadingCard[subscriptionId] = true;
    this.observed.isLoadingCard = uuidv4();
    this.env.startLoadCounter({ target: 'loadMoreSchedules' });

    const res = await getAvailableSchedulesAPI({ store: this, token: session.token, traceId, subscriptionId });

    if (res.error) return;

    delete this.isLoadingCard[subscriptionId];
    this.observed.isLoadingCard = uuidv4();
    this.env.stopLoadCounter();
    this.availableSchedulesLoaded[subscriptionId] = true;

    if (res?.data?.data) {
        this.availableSchedules[subscriptionId] = isEmpty(this.availableSchedules[subscriptionId])
            ? res.data.data
            : [...this.availableSchedules[subscriptionId], ...res.data.data];
    } else {
        this.availableSchedules[subscriptionId] = this.availableSchedules[subscriptionId] || [];
    }
    this.observed.availableSchedules = uuidv4();
    this.cardSignals.set(subscriptionId, uuidv4());
}

export default getAvailableSchedules;
